import React from 'react';
import withDeviceType from './with-device-type';

function forDevice<T1 extends {} = any, T2 extends {} = any>(
  ComponentMobile: React.FC<T1>,
  ComponentDesktop: React.FC<T2>,
) {
  return withDeviceType(({ isMobile, isDesktop, ...props }) => {
    const Component = isMobile ? ComponentMobile : ComponentDesktop;
    return <Component {...(props as T1 & T2)} />;
  }) as React.FC<T1 & T2>;
}

export default forDevice;
